import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOCommentDetail } from '../../../modal/entity.modal';

@Component({
  selector: 'app-dashboard-resolved-model',
  templateUrl: './dashboard-resolved-model.component.html',
  styleUrl: './dashboard-resolved-model.component.scss'
})
export class DashboardResolvedModelComponent {
  isSendTelegram: boolean = false;
  isSelected: boolean = false;
    commentArr: EOCommentDetail[] = [];

  resolveArr = {
    schema: '',
    description: '',
    autoResolvable: ''
  };

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<DashboardResolvedModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService, private posHttpSvcs: PosHttpService) { }
  commentObject: { textComment: string } = { textComment: '' };

  close() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.loadResolveArray();
  }

  loadResolveArray() {
    this.posHttpSvcs.authPost('v1/ui/loadResolveArray', 'loadResolveArray', this.dialogData.resolve.primaryKey).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
      }
      else {
        this.resolveArr = resp.data;
      }
    }));
  }

  loadComments(): void {
    this.posHttpSvcs.authPost('v1/ui/getEOCommentArray', 'getEOCommentArray', this.dialogData.resolve.primaryKey).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOCommentArray is not loaded");
      }
      this.commentArr = resp.data;
      this.sendtoTelegram();
    }
    );
  }

  sendtoTelegram(): void {
    let msg = `Action: Alert Resolved\n`;

    const filteredComments = this.commentArr.map(comment => {
      return comment;
    });
    if (filteredComments.length === 1) {
      const latestComment = filteredComments[filteredComments.length - 1];
      msg += `Action By : ${latestComment.commentedBy}\n`;
      msg += `Action At : ${latestComment.commentedAt}\n`;
      msg += `Comment : ${latestComment.commentText}\n`;
    } else if (filteredComments.length >= 2) {
      const lastComment = filteredComments[filteredComments.length - 1];
      const latestComment = filteredComments[filteredComments.length - 2];  
      msg += `Action By : ${lastComment.commentedBy}\n`;
      msg += `Action At : ${lastComment.commentedAt}\n`;
      msg += `Comment: ${lastComment.commentText}\n\n`;
      msg += `Last Action By : ${latestComment.commentedBy}\n`;
      msg += `Last Action At : ${latestComment.commentedAt}\n`;
      msg += `Last Comment : ${latestComment.commentText}\n`;
    }
    const pktData = {
      msg: msg,
      pk: this.dialogData.resolve.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not saved");
        return;
      }
    }));
  }

  save() {
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment here...');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      pk: this.dialogData.resolve.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/resolve', 'resolve', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      } else {
        if (this.isSendTelegram) {
          this.loadComments();
        }
        this.toaster.success(resp.data);
      }
      this.commentObject.textComment = '';
      this.dialogRef.close(resp.isError);
    }));
  }
  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
    }
    
}
interface HwDialogData {
  resolve: any;
}


